import { Typography, useMediaQuery, useTheme } from "@mui/material";

/**
 * Logo/nazwa aplikacji w AppBar
 * Zgodny z zasadą pojedynczej odpowiedzialności - tylko wyświetlanie logo
 */
export default function AppBarLogo() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Typography
      variant={isMobile ? "h6" : "h5"}
      component="div"
      sx={{
        fontWeight: 600,
        color: "#2f2f2f",
        flexGrow: 1,
      }}
    >
      Skrutiner
    </Typography>
  );
}
